export default __webpack_public_path__ + "static/media/brand_cabal.f5f8f60c.svg";